export const organisationPaths = {
    settings: '/details/settings',
    edit: '/details/edit',
    details: '/details',
};
